import { useMutation, useQueryClient } from "@tanstack/react-query"

import type { UseCaseFormData } from "../types/use-case.types"

import { useCasesQueryKeys } from "./use-cases-query-keys"
import { aiQaReview } from "../api/use-cases-api"

export function useAiQaReview() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      useCaseData,
      useCaseId,
    }: {
      useCaseData: Partial<UseCaseFormData>
      useCaseId?: string
    }) => aiQaReview(useCaseData, useCaseId),
    onSuccess: () => {
      // Invalidate list queries so dashboard picks up the new QA score
      void queryClient.invalidateQueries({ queryKey: useCasesQueryKeys.list() })
    },
  })
}
